export default __webpack_public_path__ + "static/media/equalizer.b1be0634.png";